import { render } from "./MainFooter.vue?vue&type=template&id=63fc02d0"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=63fc02d0&lang=sass"

import exportComponent from "/home/runner/work/robocleaner/robocleaner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__